import dataDescription from './dataDescription.json'
import resultsDescription from './resultsDescription.json'
import fieldsDescription from '@/tools/fieldsDescription'

export default {
  isNumber(value) {
    return !isNaN(parseFloat(value)) && !isNaN(value - 0)
  },

  displayNdigits(value, digits) {
    return this.isNumber(value)
      ? parseFloat(Number(value).toFixed(digits))
          .toLocaleString('fr', { maximumFractionDigits: digits })
          .replace(',', '.') // franglish mode : 123 456.789
          .replace('-∞', '')
          .replace('∞', '')
      : ''
  },

  buildStationViewRadius(
    constellationAltitude,
    stationMinElevation,
    stationAltitude
  ) {
    const earthRadius = 6378136.3
    let rt = earthRadius + stationAltitude
    let rs = earthRadius + constellationAltitude
    let alphaC =
      Math.acos((rt / rs) * Math.cos(stationMinElevation)) - stationMinElevation
    let r1 = earthRadius * Math.sin(alphaC) // smaller
    // let r1 = earthRadius * Math.tan(alphaC) // bigger
    return r1
  },

  computeGroundStationFieldOfViewCoordinates(
    constellationAltitude,
    groundStation
  ) {
    let earthRadius = 6378136.3
    const numberOfDegrade = 1000
    const latLngs = []
    let minElevation = groundStation.minElevation
    let rt = earthRadius + groundStation.groundStationAltitude
    let rs = earthRadius + constellationAltitude
    // Center angle
    let alpha = Math.acos((rt / rs) * Math.cos(minElevation)) - minElevation
    let ca = Math.cos(alpha)
    let lambda = groundStation.longitude
    let phi = groundStation.latitude
    if (alpha + phi > Math.PI / 2) {
      for (let i = 0; i < numberOfDegrade; i++) {
        let lonEst
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        if (lat > Math.PI - (phi + alpha)) {
          lonEst = Math.PI + lambda
        } else {
          lonEst =
            lambda +
            Math.acos(
              1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
            )
        }
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonEst)])
      }
      for (let i = numberOfDegrade; i !== 0; i--) {
        let lonOuest
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        if (lat > Math.PI - (phi + alpha)) {
          lonOuest = -Math.PI + lambda
        } else {
          lonOuest =
            lambda -
            Math.acos(
              1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
            )
        }
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonOuest)])
      }
    } else if (alpha - phi > Math.PI / 2) {
      for (let i = 0; i < numberOfDegrade; i++) {
        let lonEst
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        if (lat < alpha - phi - Math.PI) {
          lonEst = Math.PI + lambda
        } else {
          lonEst =
            lambda +
            Math.acos(
              1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
            )
        }
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonEst)])
      }
      for (let i = numberOfDegrade; i !== 0; i--) {
        let lonOuest
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        if (lat < alpha - phi - Math.PI) {
          lonOuest = -Math.PI + lambda
        } else {
          lonOuest =
            lambda -
            Math.acos(
              1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
            )
        }
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonOuest)])
      }
    } else {
      for (let i = 0; i < numberOfDegrade; i++) {
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        const lonEst =
          lambda +
          Math.acos(
            1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
          )
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonEst)])
      }
      for (let i = numberOfDegrade; i !== 0; i--) {
        const lat = -alpha + phi + ((2 * alpha) / numberOfDegrade) * i
        const lonOuest =
          lambda -
          Math.acos(
            1 + (ca - Math.cos(lat - phi)) / (Math.cos(lat) * Math.cos(phi))
          )
        latLngs.push([this.rad2deg(lat), this.rad2deg(lonOuest)])
      }
    }
    latLngs.push(latLngs[0])
    return latLngs
  },

  bps2Bps(value) {
    return this.isNumber(value) ? value / 8 : ''
  },
  bps2kBps(value) {
    return this.isNumber(value) ? value / 8000 : ''
  },
  bps2MBps(value) {
    return this.isNumber(value) ? value / 8000000 : ''
  },
  bps2GBps(value) {
    return this.isNumber(value) ? value / 8000000000 : ''
  },

  Bps2bps(value) {
    return this.isNumber(value) ? value * 8 : ''
  },
  Bps2kBps(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },
  Bps2MBps(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },
  Bps2GBps(value) {
    return this.isNumber(value) ? value / 1000000000 : ''
  },

  kBps2bps(value) {
    return this.isNumber(value) ? value * 8000 : ''
  },
  kBps2Bps(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  kBps2MBps(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },
  kBps2GBps(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },

  MBps2kBps(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  MBps2Bps(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },
  MBps2bps(value) {
    return this.isNumber(value) ? value * 8000000 : ''
  },
  MBps2GBps(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  GBps2kBps(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },
  GBps2MBps(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  GBps2Bps(value) {
    return this.isNumber(value) ? value * 1000000000 : ''
  },
  GBps2bps(value) {
    return this.isNumber(value) ? value * 8000000000 : ''
  },

  bit2B(value) {
    return this.isNumber(value) ? value / 8 : ''
  },
  bit2kB(value) {
    return this.isNumber(value) ? value / 8000 : ''
  },
  bit2MB(value) {
    return this.isNumber(value) ? value / 8000000 : ''
  },
  bit2GB(value) {
    return this.isNumber(value) ? value / 8000000000 : ''
  },

  B2bit(value) {
    return this.isNumber(value) ? value * 8 : ''
  },
  B2kB(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },
  B2MB(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },
  B2GB(value) {
    return this.isNumber(value) ? value / 1000000000 : ''
  },

  kB2bit(value) {
    return this.isNumber(value) ? value * 8000 : ''
  },
  kB2B(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  kB2MB(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },
  kB2GB(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },

  MB2kB(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  MB2B(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },
  MB2bit(value) {
    return this.isNumber(value) ? value * 8000000 : ''
  },
  MB2GB(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  GB2kB(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },
  GB2MB(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },
  GB2B(value) {
    return this.isNumber(value) ? value * 1000000000 : ''
  },
  GB2bit(value) {
    return this.isNumber(value) ? value * 8000000000 : ''
  },

  u2m3(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  m3ToU(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  km2m(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  kg2g(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  g2kg(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  kg_m32ng_m3(value) {
    return this.isNumber(value) ? value * 1000000000000 : ''
  },
  m_s22nm_s2(value) {
    return this.isNumber(value) ? value * 1000000000 : ''
  },
  nm_s22m_s2(value) {
    return this.isNumber(value) ? value / 1000000000 : ''
  },
  ng_m32kg_m3(value) {
    return this.isNumber(value) ? value / 1000000000000 : ''
  },

  m2km(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  m2cm(value) {
    return this.isNumber(value) ? value * 100 : ''
  },

  cm2m(value) {
    return this.isNumber(value) ? value / 100 : ''
  },

  m2ToCm2(value) {
    return this.isNumber(value) ? value * 10000 : ''
  },

  cm2ToM2(value) {
    return this.isNumber(value) ? value / 10000 : ''
  },

  N2mN(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  N2µN(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },

  mN2N(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },
  mN2µN(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  µN2N(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },
  µN2mN(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  Nm2mNm(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  mNm2Nm(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  Nm2µNm(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },

  µNm2Nm(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },

  Nm2nNm(value) {
    return this.isNumber(value) ? value * 1000000000 : ''
  },

  nNm2Nm(value) {
    return this.isNumber(value) ? value / 1000000000 : ''
  },

  mNm2µNm(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  µNm2mNm(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  mNm2nNm(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },

  nNm2mNm(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },

  µNm2nNm(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  nNm2µNm(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  Nms2mNms(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  mNms2Nms(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  Pa2µPa(value) {
    return this.isNumber(value) ? value * 1000000 : ''
  },

  µPa2Pa(value) {
    return this.isNumber(value) ? value / 1000000 : ''
  },

  T2nT(value) {
    return this.isNumber(value) ? value * 1000000000 : ''
  },

  nT2T(value) {
    return this.isNumber(value) ? value / 1000000000 : ''
  },

  Am22mAm2(value) {
    return this.isNumber(value) ? value * 1000 : ''
  },

  mAm22Am2(value) {
    return this.isNumber(value) ? value / 1000 : ''
  },

  deg2rad(degrees) {
    return this.isNumber(degrees) ? (degrees * Math.PI) / 180 : ''
  },

  rad2deg(radians) {
    return this.isNumber(radians) ? (radians * 180) / Math.PI : ''
  },

  sec2day(seconds) {
    return this.isNumber(seconds) ? seconds / (3600 * 24) : ''
  },

  day2sec(days) {
    return this.isNumber(days) ? days * (3600 * 24) : ''
  },

  sec2millisec(seconds) {
    return this.isNumber(seconds) ? seconds * 1000 : ''
  },

  millisec2sec(milliseconds) {
    return this.isNumber(milliseconds) ? milliseconds / 1000 : ''
  },

  sec2hour(seconds) {
    return this.isNumber(seconds) ? seconds / 3600 : ''
  },

  hour2sec(hours) {
    return this.isNumber(hours) ? hours * 3600 : ''
  },

  hour2min(hours) {
    return this.isNumber(hours) ? hours * 60 : ''
  },
  hour2day(hours) {
    return this.isNumber(hours) ? hours / 24 : ''
  },
  min2sec(min) {
    return this.isNumber(min) ? min * 60 : ''
  },
  min2hour(min) {
    return this.isNumber(min) ? min / 60 : ''
  },
  min2day(min) {
    return this.isNumber(min) ? min / (60 * 24) : ''
  },
  sec2min(sec) {
    return this.isNumber(sec) ? sec / 60 : ''
  },
  day2min(day) {
    return this.isNumber(day) ? day * (24 * 60) : ''
  },

  day2month(days) {
    return this.isNumber(days) ? days / 30 : ''
  },

  Hz2GHz(Hz) {
    return this.isNumber(Hz) ? Hz / 1000000000 : ''
  },

  GHz2Hz(GHz) {
    return this.isNumber(GHz) ? GHz * 1000000000 : ''
  },

  eurosToKeuros(euros) {
    return this.isNumber(euros) ? euros / 1000 : ''
  },

  KeurosToeuros(keuros) {
    return this.isNumber(keuros) ? keuros * 1000 : ''
  },

  keurosPerDay2eurosPerSec(value) {
    return this.isNumber(value) ? (1000 * value) / (3600 * 24) : ''
  },

  eurosPerSec2keurosPerDay(value) {
    return this.isNumber(value) ? (value * (3600 * 24)) / 1000 : ''
  },

  keurosPerKg2eurosPerKg(value) {
    return this.KeurosToeuros(value)
  },

  eurosPerKg2keurosPerKg(value) {
    return this.eurosToKeuros(value)
  },

  day2hour(days) {
    return this.isNumber(days) ? days * 24 : ''
  },

  month2day(months) {
    return this.isNumber(months) ? months * 30 : ''
  },

  month2hour(months) {
    return this.day2hour(this.month2day(months))
  },

  month2sec(months) {
    return this.hour2sec(this.month2hour(months))
  },

  kgPerSecToGramPerHour(value) {
    return this.isNumber(value) ? this.kg2g(value) * 3600 : ''
  },

  gramPerHourToKgPerSec(value) {
    return this.isNumber(value) ? this.g2kg(value) / 3600 : ''
  },

  radsec2degsec(value) {
    return this.isNumber(value) ? this.rad2deg(value) : ''
  },

  radsec2deghour(value) {
    return this.isNumber(value) ? this.radsec2degsec(value) * 3600 : ''
  },

  radsec2degday(value) {
    return this.isNumber(value) ? this.radsec2degsec(value) * (3600 * 24) : ''
  },

  radsec22degsec2(value) {
    return this.isNumber(value) ? this.rad2deg(value) : ''
  },

  degsec2radsec(value) {
    return this.isNumber(value) ? this.deg2rad(value) : ''
  },

  degsec22radsec2(value) {
    return this.isNumber(value) ? this.deg2rad(value) : ''
  },

  timesec2timeday(value) {
    return this.isNumber(value) ? value * (3600 * 24) : ''
  },

  timeday2timesec(value) {
    return this.isNumber(value) ? value / (3600 * 24) : ''
  },

  deg2hours(value) {
    return this.isNumber(value) ? value / 15 : ''
  },

  hours2deg(value) {
    return this.isNumber(value) ? value * 15 : ''
  },

  radsec2hourday(value) {
    return this.isNumber(value) ? this.deg2hours(this.radsec2degday(value)) : ''
  },

  rad2hours(value) {
    return this.deg2hours(this.rad2deg(value))
  },

  float2percent(value) {
    return this.isNumber(value) ? value * 100 : ''
  },

  percent2float(value) {
    return this.isNumber(value) ? value / 100 : ''
  },
  watt2dB(value) {
    return this.isNumber(value) ? 10 * Math.log10(value) : ''
  },
  dB2watt(value) {
    return this.isNumber(value) ? Math.pow(10, value / 10) : ''
  },

  updateRFLinkPath(path) {
    if (path[0].startsWith('linkMargin')) {
      path[0] = 'linkMargin'
    } else if (path[0].startsWith('linkElevation')) {
      path[0] = 'linkElevation'
    } else if (path[0].startsWith('linkEbN0')) {
      path[0] = 'linkEbN0'
    } else if (path[0].startsWith('linkFreeSpacePathLoss')) {
      path[0] = 'linkFreeSpacePathLoss'
    } else if (path[0].startsWith('linkAtmLoss')) {
      path[0] = 'linkAtmLoss'
    } else if (path[0].startsWith('linkIonosphereLoss')) {
      path[0] = 'linkIonosphereLoss'
    } else if (path[0].startsWith('linkIsotropicSignalAtReceiver')) {
      path[0] = 'linkIsotropicSignalAtReceiver'
    } else if (path[0].startsWith('linkAllEnvironmentLosses')) {
      path[0] = 'linkAllEnvironmentLosses'
    } else if (path[0].startsWith('linkSignalToNoisePowerDensity')) {
      path[0] = 'linkSignalToNoisePowerDensity'
    }
  },

  getResultFieldFromPath(pathOrigin, context) {
    // TODO this method should be unit tested with all path

    const path = [...pathOrigin]
    if (typeof path[0] === 'string' && path[0].startsWith('link')) {
      this.updateRFLinkPath(path)
    }

    let startIndex = path[0] === 'subMissions' ? 2 : 0
    let field = resultsDescription[context][path[startIndex]]
    const currentPath = new Array()
    currentPath.push(field)
    startIndex = startIndex + 1
    for (let i = startIndex; i < path.length; i++) {
      // Handle list of values
      if (!this.isNumber(path[i])) {
        field = resultsDescription[field.type][path[i]]
      } else if (
        this.isNumber(path[i]) &&
        (field.type === 'vector' || field.type === 'matrix')
      ) {
        field =
          resultsDescription[currentPath[i - 2].type][field.dimensions[path[i]]]
      }
      currentPath.push(field)
    }
    return field
  },

  shouldListPropertiesInThisSubTree(currentDescription, subTypes) {
    if (subTypes == null) {
      // list all possibilities
      return true
    }
    if (currentDescription.oneOf != null) {
      for (let oneOfKey of Object.keys(currentDescription.oneOf)) {
        for (let oneOfValue of Object.keys(
          currentDescription.oneOf[oneOfKey]
        )) {
          if (subTypes[oneOfKey] === oneOfValue) {
            // one of the sub types matches this tree
            return true
          }
          // recursive check
          if (currentDescription.oneOf[oneOfKey][oneOfValue].oneOf != null) {
            if (
              this.shouldListPropertiesInThisSubTree(
                currentDescription.oneOf[oneOfKey][oneOfValue],
                subTypes
              )
            ) {
              return true
            }
          }
        }
      }
    }
    // no match here or in sub trees
    return false
  },

  getPropertiesList(currentDescription, subTypes, optionalOrRequiredTag) {
    let list = []
    if (this.shouldListPropertiesInThisSubTree(currentDescription, subTypes)) {
      if (currentDescription[optionalOrRequiredTag] != null) {
        list = list.concat(currentDescription[optionalOrRequiredTag])
      }
    }
    // recursive part
    if (currentDescription.oneOf != null) {
      for (let oneOfKey of Object.keys(currentDescription.oneOf)) {
        for (let oneOfValue of Object.keys(
          currentDescription.oneOf[oneOfKey]
        )) {
          let subTypeDescription =
            currentDescription.oneOf[oneOfKey][oneOfValue]
          if (subTypes == null || subTypes[oneOfKey] === oneOfValue) {
            // one of the sub types matches this tree
            if (subTypeDescription[optionalOrRequiredTag] != null) {
              list = list.concat(subTypeDescription[optionalOrRequiredTag])
            }
            list = list.concat(
              this.getPropertiesList(
                subTypeDescription,
                subTypes,
                optionalOrRequiredTag
              )
            )
          }
        }
      }
    }
    return [...new Set(list)] // remove duplicates
  },

  isValidResultPath(path) {
    return (
      Array.isArray(path) &&
      path.length > 0 &&
      path[0] !== '' &&
      !(path.length === 1 && path[0] === 'subMissions') &&
      !(path.length === 2 && path[0] === 'subMissions')
    )
  },

  isCustomFieldPath(path) {
    return path[0] === 'scriptInputs' || path[0] === 'scriptOutputs'
  },

  getFieldTypeFromPath(path, context, scriptConfig) {
    if (!this.isValidResultPath(path)) {
      return ''
    }
    if (this.isCustomFieldPath(path)) {
      let topBranch = path[0]
      let customFieldName = path[1]
      if (
        scriptConfig &&
        scriptConfig[topBranch] != null &&
        customFieldName != null
      ) {
        return scriptConfig[topBranch][customFieldName].type
      } else {
        return ''
      }
    }
    let field = this.getResultFieldFromPath(path, context)
    if (field == null) {
      console.log(
        'getFieldTypeFromPath : Unknown result field ' + path + ' in ' + context
      )
      return ''
    }
    if (field.type != null) {
      return field.type
    }
    return ''
  },

  getFieldLabelFromPath(path, context) {
    if (!this.isValidResultPath(path)) {
      return ''
    }
    if (this.isCustomFieldPath(path)) {
      if (path.length >= 2) {
        return path[1]
      } else {
        return ''
      }
    }

    let field = this.getResultFieldFromPath(path, context)
    if (field == null) {
      console.log(
        'getFieldLabelFromPath : Unknown result field ' +
          path +
          ' in ' +
          context
      )
      return ''
    }
    return field.label
  },

  getFieldPriorityFromPath(path, context) {
    if (!this.isValidResultPath(path)) {
      return ''
    }
    if (this.isCustomFieldPath(path)) {
      return ''
    }

    let field = this.getResultFieldFromPath(path, context)
    if (field == null) {
      console.log(
        'getFieldPriorityFromPath : Unknown result field ' +
          path +
          ' in ' +
          context
      )
      return ''
    }
    return field.priority
  },

  getFieldValueFromPath(path, context) {
    let value = ''
    let currentContext = context
    for (let i = 0; i < path.length; i++) {
      currentContext = currentContext[path[i]]
      if (i < path.length - 1 && currentContext == null) {
        console.log('Unknown path ' + path + ' in context')
        return ''
      } else if (i === path.length - 1) {
        value = currentContext
      }
    }
    return value
  },

  getSiUnit(fieldType) {
    if (dataDescription[fieldType] == null) {
      return ''
    }
    let siUnit = dataDescription[fieldType].siUnit
    if (siUnit == null) {
      siUnit = ''
    }
    return siUnit
  },

  getDefaultGuiUnit(fieldType) {
    if (dataDescription[fieldType] == null) {
      return ''
    }
    let guiUnit = dataDescription[fieldType].guiUnit
    if (guiUnit == null) {
      guiUnit = ''
    }
    return guiUnit
  },

  getAvailableUnits(fieldType) {
    return this.getConversionUnits(this.getSiUnit(fieldType)).filter(
      (unit) => unit !== 'DHMS'
    ) // delete the DHMS for plot Units
  },

  getConversionUnits(sourceUnit) {
    let units = [sourceUnit]
    switch (sourceUnit) {
      case 'bps':
      case 'B/s':
      case 'kB/s':
      case 'MB/s':
      case 'GB/s':
        units = ['bps', 'B/s', 'kB/s', 'MB/s', 'GB/s']
        break
      case 'bit':
      case 'B':
      case 'kB':
      case 'MB':
      case 'GB':
        units = ['bit', 'B', 'kB', 'MB', 'GB']
        break
      case 'mN':
      case 'µN':
      case 'N':
        units = ['N', 'mN', 'µN']
        break
      case 'nN.m':
      case 'µN.m':
      case 'mN.m':
      case 'N.m':
        units = ['N.m', 'mN.m', 'µN.m', 'nN.m']
        break
      case 'N.m.s':
      case 'mN.m.s':
        units = ['N.m.s', 'mN.m.s']
        break
      case 'nT':
      case 'T':
        units = ['T', 'nT']
        break
      case 'nm/s²':
      case 'm/s²':
        units = ['m/s²', 'nm/s²']
        break
      case 'mA.m²':
      case 'A.m²':
        units = ['A.m²', 'mA.m²']
        break
      case '€':
      case 'k€':
        units = ['k€', '€']
        break
      case 'km':
        units = ['km', 'm']
        break
      case 'cm':
        units = ['cm', 'm']
        break
      case 'm':
        units = ['cm', 'm', 'km']
        break
      case 'rad':
      case 'deg':
        units = ['rad', 'deg', '24h00']
        break
      case '24h00':
        units = ['rad', 'deg', 's']
        break
      case 's':
        units = ['ms', 'min', 'h', 'days', 'DHMS', '24h00']
        break
      case 'ms':
        units = ['s']
        break
      case 'h':
      case 'min':
      case 'days':
        units = ['s', 'min', 'h', 'days', 'DHMS']
        break
      case 'rad/s':
        units = ['rad/s', 'deg/s', 'deg/day', 'h/day', 'deg/h']
        break
      case 'rad/s²':
      case 'deg/s²':
        units = ['rad/s²', 'deg/s²']
        break
      case 'kg':
        units = ['g', 'kg']
        break
      case 'kg/m³':
      case 'ng/m³':
        units = ['kg/m³', 'ng/m³']
        break
      case 'm²':
      case 'cm²':
        units = ['m²', 'cm²']
        break
      case 'm³':
      case 'U':
        units = ['U', 'm³']
        break
      case '€/s':
      case 'k€/day':
        units = ['€/s', 'k€/day']
        break
      case 'times/s':
      case 'times/day':
        units = ['times/s', 'times/day']
        break
      case '€/kg':
      case 'k€/kg':
        units = ['€/kg', 'k€/kg']
        break
      case '':
        units = ['%']
        break
      case 'kg/s':
      case 'g/h':
        units = ['kg/s', 'g/h']
        break
      case 'W':
      case 'dB':
        units = ['W', 'dB']
        break
      default:
        break
    }
    return units
  },

  convertPiToNumber(n) {
    const piRegex = /^(-?)\s*((\d)\s*\*?)?\s*(PI)\s*(\/\s*(\d?))?$/
    let value = n
    if (value != null && !this.isNumber(value)) {
      let matching = piRegex.exec(value)
      if (matching) {
        let coeff = 1
        if (matching[1] != null && matching[1] === '-') {
          coeff = -coeff
        }
        // look for x * PI
        if (matching[3] != null && matching[3] !== '') {
          coeff = parseInt(matching[3]) * coeff
        }
        // look for PI / x
        if (matching[6] != null && matching[6] !== '') {
          coeff = coeff / parseInt(matching[6])
        }
        value = coeff * Math.PI
      }
    }
    return value
  },

  convertFromSi(fieldType, value, targetUnit) {
    let siUnit = this.getSiUnit(fieldType)
    if (siUnit === targetUnit) {
      return value // no conversion
    }
    return this.removeApproximationDigits(
      this.convertUnits(value, siUnit, targetUnit)
    )
  },

  getNbToDisplay(unit) {
    let digits = null
    switch (unit) {
      case 'GB/s':
        digits = 2
        break
      case 'MB/s':
        digits = 2
        break
      case 'kB/s':
        digits = 2
        break
      case 'B/s':
        digits = 0
        break
      case 'B':
        digits = 0
        break
      case 'kB':
        digits = 2
        break
      case 'MB':
        digits = 2
        break
      case 'GB':
        digits = 2
        break
      case 'mN':
        digits = 2
        break
      case 'N':
        digits = 3
        break
      case 'N.m':
        digits = 3
        break
      case 'mN.m':
        digits = 3
        break
      case 'µN.m':
        digits = 3
        break
      case 'nN.m':
        digits = 3
        break
      case 'N.m.s':
        digits = 3
        break
      case 'mN.m.s':
        digits = 3
        break
      case 'T':
        digits = 9
        break
      case 'nT':
        digits = 0
        break
      case 'A.m²':
        digits = 3
        break
      case 'mA.m²':
        digits = 3
        break
      case 'km':
        digits = 3
        break
      case 'm':
        digits = 2
        break
      case 'cm':
        digits = 1
        break
      case 'rad':
        digits = 2
        break
      case 'deg':
        digits = 2
        break
      case 'h':
        digits = 2
        break
      case 'min':
        digits = 2
        break
      case 's':
        digits = 0
        break
      case 'ms':
        digits = 0
        break
      case 'days':
        digits = 2
        break
      case 'deg/h':
      case 'deg/s':
      case 'deg/s²':
      case 'rad/s':
      case 'rad/s²':
        digits = 2
        break
      case 'g':
        digits = 0
        break
      case 'kg':
        digits = 3
        break
      case 'm²':
        digits = 2
        break
      case 'cm²':
        digits = 0
        break
      case 'm³':
        digits = 3
        break
      case 'U':
        digits = 2
        break
      case '€':
        digits = 0
        break
      case 'k€':
        digits = 3
        break
      case '€/s':
        digits = 0
        break
      case '€/kg':
        digits = 0
        break
      case 'k€/kg':
        digits = 3
        break
      case 'times/s':
        digits = 9
        break
      case 'times/day':
        digits = 2
        break
      case '%':
        digits = 2
        break
      case 'k€/s':
        digits = 3
        break
      case 'k€/day':
        digits = 3
        break
      case '':
        digits = 4
        break
      case 'kg/s':
        digits = 3
        break
      case 'g/h':
        digits = 2
        break
      case 'kg/m³':
        digits = 18
        break
      case 'ng/m³':
        digits = 3
        break
      case 'deg/day':
        digits = 3
        break
      case 'h/day':
        digits = 2
        break
      case 'm/s':
        digits = 2
        break
      case 'm/s²':
        digits = 3
        break
      case 'W':
        digits = 2
        break
      case 'dB':
        digits = 2
        break
      case 'N.s':
        digits = 1
        break
      case 'nm/s²':
        digits = 2
        break
      case 'µN':
        digits = 2
        break
      default:
        digits = null
        break
    }
    return digits
  },

  convertUnits(value, srcUnit, targetUnit) {
    let converted = value
    switch (srcUnit) {
      case 'GB/s':
        if (targetUnit === 'bps') {
          converted = this.GBps2bps(value)
        }
        if (targetUnit === 'B/s') {
          converted = this.GBps2Bps(value)
        }
        if (targetUnit === 'MB/s') {
          converted = this.GBps2MBps(value)
        }
        if (targetUnit === 'kB/s') {
          converted = this.GBps2kBps(value)
        }
        break
      case 'MB/s':
        if (targetUnit === 'bps') {
          converted = this.MBps2bps(value)
        }
        if (targetUnit === 'B/s') {
          converted = this.MBps2Bps(value)
        }
        if (targetUnit === 'kB/s') {
          converted = this.MBps2kBps(value)
        }
        if (targetUnit === 'GB/s') {
          converted = this.MBps2GBps(value)
        }
        break
      case 'kB/s':
        if (targetUnit === 'bps') {
          converted = this.kBps2bps(value)
        }
        if (targetUnit === 'B/s') {
          converted = this.kBps2Bps(value)
        }
        if (targetUnit === 'MB/s') {
          converted = this.kBps2MBps(value)
        }
        if (targetUnit === 'GB/s') {
          converted = this.kBps2GBps(value)
        }
        break
      case 'B/s':
        if (targetUnit === 'bps') {
          converted = this.Bps2bps(value)
        }
        if (targetUnit === 'kB/s') {
          converted = this.Bps2kBps(value)
        }
        if (targetUnit === 'MB/s') {
          converted = this.Bps2MBps(value)
        }
        if (targetUnit === 'GB/s') {
          converted = this.Bps2GBps(value)
        }
        break
      case 'bps':
        if (targetUnit === 'B/s') {
          converted = this.bps2Bps(value)
        }
        if (targetUnit === 'kB/s') {
          converted = this.bps2kBps(value)
        }
        if (targetUnit === 'MB/s') {
          converted = this.bps2MBps(value)
        }
        if (targetUnit === 'GB/s') {
          converted = this.bps2GBps(value)
        }
        break
      case 'GB':
        if (targetUnit === 'bit') {
          converted = this.GB2bit(value)
        }
        if (targetUnit === 'B') {
          converted = this.GB2B(value)
        }
        if (targetUnit === 'MB') {
          converted = this.GB2MB(value)
        }
        if (targetUnit === 'kB') {
          converted = this.GB2kB(value)
        }
        break
      case 'MB':
        if (targetUnit === 'bit') {
          converted = this.MB2bit(value)
        }
        if (targetUnit === 'B') {
          converted = this.MB2B(value)
        }
        if (targetUnit === 'kB') {
          converted = this.MB2kB(value)
        }
        if (targetUnit === 'GB') {
          converted = this.MB2GB(value)
        }
        break
      case 'kB':
        if (targetUnit === 'bit') {
          converted = this.kB2bit(value)
        }
        if (targetUnit === 'B') {
          converted = this.kB2B(value)
        }
        if (targetUnit === 'MB') {
          converted = this.kB2MB(value)
        }
        if (targetUnit === 'GB') {
          converted = this.kB2GB(value)
        }
        break
      case 'B':
        if (targetUnit === 'bit') {
          converted = this.B2bit(value)
        }
        if (targetUnit === 'kB') {
          converted = this.B2kB(value)
        }
        if (targetUnit === 'MB') {
          converted = this.B2MB(value)
        }
        if (targetUnit === 'GB') {
          converted = this.B2GB(value)
        }
        break
      case 'bit':
        if (targetUnit === 'B') {
          converted = this.bit2B(value)
        }
        if (targetUnit === 'kB') {
          converted = this.bit2kB(value)
        }
        if (targetUnit === 'MB') {
          converted = this.bit2MB(value)
        }
        if (targetUnit === 'GB') {
          converted = this.bit2GB(value)
        }
        break
      case 'mN':
        if (targetUnit === 'N') {
          converted = this.mN2N(value)
        }
        if (targetUnit === 'µN') {
          converted = this.mN2µN(value)
        }
        break
      case 'µN':
        if (targetUnit === 'N') {
          converted = this.µN2N(value)
        }
        if (targetUnit === 'mN') {
          converted = this.µN2mN(value)
        }
        break
      case 'N':
        if (targetUnit === 'mN') {
          converted = this.N2mN(value)
        }
        if (targetUnit === 'µN') {
          converted = this.N2µN(value)
        }
        break
      case 'N.m':
        if (targetUnit === 'mN.m') {
          converted = this.Nm2mNm(value)
        }
        if (targetUnit === 'µN.m') {
          converted = this.Nm2µNm(value)
        }
        if (targetUnit === 'nN.m') {
          converted = this.Nm2nNm(value)
        }
        break
      case 'mN.m':
        if (targetUnit === 'N.m') {
          converted = this.mNm2Nm(value)
        }
        if (targetUnit === 'µN.m') {
          converted = this.mNm2µNm(value)
        }
        if (targetUnit === 'nN.m') {
          converted = this.mNm2nNm(value)
        }
        break
      case 'µN.m':
        if (targetUnit === 'N.m') {
          converted = this.µNm2Nm(value)
        }
        if (targetUnit === 'mN.m') {
          converted = this.µNm2mNm(value)
        }
        if (targetUnit === 'nN.m') {
          converted = this.µNm2nNm(value)
        }
        break
      case 'nN.m':
        if (targetUnit === 'N.m') {
          converted = this.nNm2Nm(value)
        }
        if (targetUnit === 'mN.m') {
          converted = this.nNm2mNm(value)
        }
        if (targetUnit === 'µN.m') {
          converted = this.nNm2µNm(value)
        }
        break
      case 'N.m.s':
        if (targetUnit === 'mN.m.s') {
          converted = this.Nms2mNms(value)
        }
        break
      case 'mN.m.s':
        if (targetUnit === 'N.m.s') {
          converted = this.mNms2Nms(value)
        }
        break
      case 'Pa':
        if (targetUnit === 'µPa') {
          converted = this.Pa2µPa(value)
        }
        break
      case 'µPa':
        if (targetUnit === 'Pa') {
          converted = this.µPa2Pa(value)
        }
        break
      case 'T':
        if (targetUnit === 'nT') {
          converted = this.T2nT(value)
        }
        break
      case 'nT':
        if (targetUnit === 'T') {
          converted = this.nT2T(value)
        }
        break
      case 'A.m²':
        if (targetUnit === 'mA.m²') {
          converted = this.Am22mAm2(value)
        }
        break
      case 'mA.m²':
        if (targetUnit === 'A.m²') {
          converted = this.mAm22Am2(value)
        }
        break
      case 'km':
        if (targetUnit === 'm') {
          converted = this.km2m(value)
        }
        break
      case 'm':
        if (targetUnit === 'km') {
          converted = this.m2km(value)
        }
        if (targetUnit === 'cm') {
          converted = this.m2cm(value)
        }
        break
      case 'cm':
        if (targetUnit === 'm') {
          converted = this.cm2m(value)
        }
        break
      case 'deg':
        if (targetUnit === 'rad') {
          converted = this.deg2rad(value)
        } else if (targetUnit === '24h00') {
          converted = this.sec2hms(this.hour2sec(this.deg2hours(value)))
        }
        break
      case 'rad':
        if (targetUnit === 'deg') {
          converted = this.rad2deg(value)
        } else if (targetUnit === '24h00') {
          converted = this.sec2hms(this.hour2sec(this.rad2hours(value)))
        }
        break
      case '24h00':
        if (targetUnit === 'deg') {
          converted = this.hours2deg(this.sec2hour(this.hms2sec(value)))
        } else if (targetUnit === 'rad') {
          converted = this.deg2rad(
            this.hours2deg(this.sec2hour(this.hms2sec(value)))
          )
        } else if (targetUnit === 's') {
          converted = this.hms2sec(value)
        }
        break
      case 'h':
        if (targetUnit === 's') {
          converted = this.hour2sec(value)
        } else if (targetUnit === 'min') {
          converted = this.hour2min(value)
        } else if (targetUnit === 'days') {
          converted = this.hour2day(value)
        } else if (targetUnit === 'DHMS') {
          converted = this.sec2DHMS(this.hour2sec(value))
        }
        break
      case 'min':
        if (targetUnit === 's') {
          converted = this.min2sec(value)
        } else if (targetUnit === 'h') {
          converted = this.min2hour(value)
        } else if (targetUnit === 'days') {
          converted = this.min2day(value)
        } else if (targetUnit === 'DHMS') {
          converted = this.sec2DHMS(this.min2sec(value))
        }
        break
      case 's':
        if (targetUnit === 'h') {
          converted = this.sec2hour(value)
        } else if (targetUnit === 'min') {
          converted = this.sec2min(value)
        } else if (targetUnit === 'days') {
          converted = this.sec2day(value)
        } else if (targetUnit === 'DHMS') {
          converted = this.sec2DHMS(value)
        } else if (targetUnit === '24h00') {
          converted = this.sec2hms(value)
        } else if (targetUnit === 'ms') {
          converted = this.sec2millisec(value)
        }
        break
      case 'ms':
        if (targetUnit === 's') {
          converted = this.millisec2sec(value)
        }
        break
      case 'days':
        if (targetUnit === 's') {
          converted = this.day2sec(value)
        } else if (targetUnit === 'min') {
          converted = this.day2min(value)
        } else if (targetUnit === 'h') {
          converted = this.day2hour(value)
        } else if (targetUnit === 'DHMS') {
          converted = this.sec2DHMS(this.day2sec(value))
        }
        break
      case 'Hz':
        if (targetUnit === 'GHz') {
          converted = this.Hz2GHz(value)
        }
        break
      case 'GHz':
        if (targetUnit === 'Hz') {
          converted = this.GHz2Hz(value)
        }
        break
      case 'rad/s':
        if (targetUnit === 'deg/s') {
          converted = this.radsec2degsec(value)
        } else if (targetUnit === 'deg/day') {
          converted = this.radsec2degday(value)
        } else if (targetUnit === 'deg/h') {
          converted = this.radsec2deghour(value)
        } else if (targetUnit === 'h/day') {
          converted = this.radsec2hourday(value)
        }
        break
      case 'rad/s²':
        if (targetUnit === 'deg/s²') {
          converted = this.radsec22degsec2(value)
        }
        break
      case 'deg/s':
        if (targetUnit === 'rad/s') {
          converted = this.degsec2radsec(value)
        }
        break
      case 'deg/s²':
        if (targetUnit === 'rad/s²') {
          converted = this.degsec22radsec2(value)
        }
        break
      case 'kg':
        if (targetUnit === 'g') {
          converted = this.kg2g(value)
        }
        break
      case 'kg/m³':
        if (targetUnit === 'ng/m³') {
          converted = this.kg_m32ng_m3(value)
        }
        break
      case 'm/s²':
        if (targetUnit === 'nm/s²') {
          converted = this.m_s22nm_s2(value)
        }
        break
      case 'nm/s²':
        if (targetUnit === 'm/s²') {
          converted = this.nm_s22m_s2(value)
        }
        break
      case 'ng/m³':
        if (targetUnit === 'kg/m³') {
          converted = this.ng_m32kg_m3(value)
        }
        break
      case 'm²':
        if (targetUnit === 'cm²') {
          converted = this.m2ToCm2(value)
        }
        break
      case 'cm²':
        if (targetUnit === 'm²') {
          converted = this.cm2ToM2(value)
        }
        break
      case 'm³':
        if (targetUnit === 'U') {
          converted = this.m3ToU(value)
        }
        break
      case 'U':
        if (targetUnit === 'm³') {
          converted = this.u2m3(value)
        }
        break
      case 'kg/s':
        if (targetUnit === 'g/h') {
          converted = this.kgPerSecToGramPerHour(value)
        }
        break
      case 'g/h':
        if (targetUnit === 'kg/s') {
          converted = this.gramPerHourToKgPerSec(value)
        }
        break
      case '€':
        if (targetUnit === 'k€') {
          converted = this.eurosToKeuros(value)
        }
        break
      case 'k€':
        if (targetUnit === '€') {
          converted = this.KeurosToeuros(value)
        }
        break
      case '€/s':
        if (targetUnit === 'k€/day') {
          converted = this.eurosPerSec2keurosPerDay(value)
        }
        break
      case 'k€/day':
        if (targetUnit === '€/s') {
          converted = this.keurosPerDay2eurosPerSec(value)
        }
        break
      case '€/kg':
        if (targetUnit === 'k€/kg') {
          converted = this.eurosPerKg2keurosPerKg(value)
        }
        break
      case 'k€/kg':
        if (targetUnit === '€/kg') {
          converted = this.keurosPerKg2eurosPerKg(value)
        }
        break
      case 'times/s':
        if (targetUnit === 'times/day') {
          converted = this.day2sec(value)
        }
        break
      case 'times/day':
        if (targetUnit === 'times/s') {
          converted = this.sec2day(value)
        }
        break
      case '':
        if (targetUnit === '%') {
          converted = this.float2percent(value)
        }
        break
      case '%':
        if (targetUnit === '') {
          converted = this.percent2float(value)
        }
        break
      case 'W':
        if (targetUnit === 'dB') {
          converted = this.watt2dB(value)
        }
        break
      case 'dB':
        if (targetUnit === 'W') {
          converted = this.dB2watt(value)
        }
        break
      default:
        break
    }
    return converted
  },

  // display empty fields on right, e.g. 3h05mn00s
  sec2DDHHMMSS(secs) {
    if (!this.isNumber(secs) || secs.toString().includes('Infinity')) {
      return ''
    }
    if (secs < 0) {
      return (
        '-' + this.filterEmptyValues(this.sec2DHMSVector(Math.abs(secs)), false)
      )
    }
    return this.filterEmptyValues(this.sec2DHMSVector(secs), false)
  },

  sec2DHMSVector(secs) {
    let secNum = parseInt(secs, 10)
    let days = Math.floor(secNum / 86400)
    let hours = Math.floor(secNum / 3600) % 24
    let minutes = Math.floor(secNum / 60) % 60
    let seconds = secNum % 60

    return [days, hours, minutes, seconds]
      .map((v, i) => (v < 10 ? '0' + v : '' + v))
      .map((v, i) => v + this.getDHMSvectorUnits()[i])
  },

  getDHMSvectorUnits() {
    return ['d', 'h', 'min', 's']
  },

  filterEmptyValues(data, removeIfEmptyOnRight) {
    let indexToKeep = []
    for (let i in data) {
      const iAsInt = parseInt(i, 10)
      let remove = false
      let emptyOnLeft = true
      for (let j = 0; j < iAsInt; j++) {
        emptyOnLeft = emptyOnLeft && !indexToKeep[j]
      }

      const empty = data[iAsInt].startsWith('00')
      if (iAsInt === 0) {
        // 1st left = days
        remove = empty
      } else if (iAsInt === data.length - 1) {
        // last right
        remove = empty && !emptyOnLeft
      } else {
        // in the middle
        if (empty) {
          let emptyOnRight = removeIfEmptyOnRight
          for (let j = iAsInt + 1; j < data.length; j++) {
            emptyOnRight = emptyOnRight && data[j].startsWith('00')
          }
          remove = emptyOnLeft || emptyOnRight
        }
      }
      indexToKeep[iAsInt] = !remove
    }
    const dataFiltered = data.filter((v, i) => indexToKeep[i])
    let ret = ''
    for (let val of dataFiltered) {
      ret = ret + val
    }
    if (ret.startsWith('0')) {
      ret = ret.substr(1)
    }
    return ret
  },

  // hide empty fields on right, e.g. 1d03h 3h05mn 15mn20s
  sec2DHMS(secs) {
    if (!this.isNumber(secs) || secs.toString().includes('Infinity')) {
      return ''
    }
    return this.filterEmptyValues(this.sec2DHMSVector(secs), true)
  },

  // 24h00
  hms2sec(value) {
    let res = ''

    if (this.isNumber(value)) {
      res = parseFloat(value) * 60 * 60
    } else {
      const parts = value.split('h')
      const hours = parts[0]

      if (this.isNumber(hours)) {
        res = parseFloat(hours) * 60 * 60
        if (parts.length > 1) {
          let mn = parts[1]
          if (this.isNumber(mn)) {
            res += parseFloat(mn) * 60
          }
        }
      }
    }
    return res
  },

  sec2hms(value) {
    if (!this.isNumber(value)) {
      return ''
    }
    let secNum = parseInt(value, 10)
    let hours = Math.floor(secNum / 3600)
    let minutes = Math.floor(secNum / 60) % 60
    let res = hours + 'h'
    if (minutes > 0) {
      const mn = minutes < 10 ? '0' + minutes : '' + minutes
      res += mn
    }
    return res
  },

  formatIso8601String(format, value) {
    switch (format) {
      case 'isoDateTime':
        return value.substring(0, 19)
      default:
        return value
    }
  },

  removeApproximationDigits(value) {
    if (this.isNumber(value)) {
      // to deal with with internal representation of double :  internal double values
      // 0.014999999999999999 === 0.0150000000000000001
      return Math.round(value * 1e6) / 1e6
    }
    return value
  },

  convertSi2gui(fieldType, value) {
    if (fieldType === 'list') {
      return value
    }
    if (fieldType === 'isoDateTime') {
      return this.formatIso8601String(fieldType, value)
    }
    if (
      value === '' ||
      value === 'NaN' ||
      value == null ||
      value === undefined
    ) {
      return ''
    }
    let inputValue = this.convertFromSi(
      fieldType,
      value,
      this.getDefaultGuiUnit(fieldType)
    )

    return inputValue
  },

  convertSi2Display(fieldType, value) {
    if (value === '' || value == null || value === undefined) {
      return ''
    }
    let result = this.convertSi2gui(fieldType, value)
    if (
      dataDescription[fieldType] == null ||
      result.toString().includes('Infinity')
    ) {
      return result
    }
    return this.displayTypeDigits(fieldType, result)
  },

  displayTypeDigits(fieldType, value) {
    return this.displayTypeDigitsFromUnit(
      dataDescription[fieldType].guiUnit,
      value
    )
  },
  convertEnum2Display(context, path, value) {
    let field = this.getResultFieldFromPath(path, context)
    if (field == null) {
      console.log(
        'convertEnum2Display : Unknown result field ' + path + ' in ' + context
      )
      return ''
    }
    for (const enumValue of field.values) {
      if (enumValue.value === value) {
        return enumValue.text
      }
    }
    return value
  },
  displayTypeDigitsFromUnit(guiUnit, value) {
    let nbDigits = this.getNbToDisplay(guiUnit)
    if (nbDigits != null) {
      return this.displayNdigits(value, nbDigits)
    }
    return value
  },

  convertGui2si(fieldType, value) {
    return this.convert2si(fieldType, value, this.getDefaultGuiUnit(fieldType))
  },

  convert2si(fieldType, value, srcUnit) {
    let val = this.convertUnits(value, srcUnit, this.getSiUnit(fieldType))
    // do not remove approximation digits when converting to SI, we want to keep the precision in order to perform correctly the translation back
    if (val === '') {
      val = null
    }
    return val
  },

  getAllValues(elements, fieldPath) {
    if (elements == null) {
      return []
    }
    return elements.map((element) => this.getValue(element, fieldPath))
  },

  getUniqueValues(elements, fieldPath) {
    let values = new Set()
    for (let aResult of elements) {
      let currentValue = this.getValue(aResult, fieldPath)
      if (currentValue != null && currentValue !== '') {
        values.add(currentValue)
      }
    }
    return [...values]
  },

  filterDataPathWithMultipleValues(allDataPaths, results) {
    return allDataPaths.filter((dataPath) =>
      this.isDataPathWithMultipleValues(dataPath, results)
    )
  },

  isDataPathWithMultipleValues(dataPath, results) {
    let firstValueFound = null
    for (let aResult of results) {
      let currentValue = this.getValue(aResult, dataPath)
      if (currentValue != null && currentValue !== '') {
        if (firstValueFound == null) {
          firstValueFound = currentValue
        } else if (firstValueFound !== currentValue) {
          // 2 different values : can be kept
          return true
        }
      }
    }
    return false
  },

  getValue(element, fieldPath) {
    let val = element
    for (let pathPart of fieldPath) {
      val = val[pathPart]
      if (val == null) {
        // console.log('No ' + fieldPath + ' in ' + JSON.stringify(element) + ', ' + pathPart + ' not found')
        return ''
      }
    }
    return val
  },

  getUnitLabel(unitField) {
    return this.getUnitDisplayed(unitField) !== '' ? ' (' + unitField + ')' : ''
  },

  getUnitDisplayed(unitField) {
    return unitField !== '' && unitField !== '24h00' && unitField !== 'DHMS'
      ? unitField
      : ''
  },

  formatToHuman(name) {
    return name
      .replace(/([A-Z])/g, ' $1')
      .replace(/^\w/, (c) => c.toUpperCase())
  },

  getDataLabel(dataPath) {
    if (dataPath == null || !dataPath.length > 0) {
      return ''
    } else {
      let label = this.formatToHuman(dataPath[dataPath.length - 1])
      if (dataPath.length > 1) {
        label = this.formatToHuman(dataPath[dataPath.length - 2]) + ' ' + label
      }
      return label
    }
  },

  convertSimulationData(data, fieldIndexes) {
    if (!data || !fieldIndexes) {
      return []
    }
    let convertedData = []
    if (data != null) {
      data.forEach((element) => {
        let object = {}
        for (const key in fieldIndexes) {
          object[key] = element[fieldIndexes[key]]
        }
        convertedData.push(object)
      })
    }
    return convertedData
  },

  // set the missing leaf to NaN
  harmonizeStructure(results) {
    let resultsStructure = this.buildResultsStructure(results)
    this.updateResultsWithStructure(results, resultsStructure)
    return results
  },

  updateResultsWithStructure(results, resultsStructure) {
    for (let resultIndex in results) {
      this.updateStructure(results[resultIndex], resultsStructure)
    }
  },

  buildResultsStructure(results) {
    let structure = {}
    for (let resultIndex in results) {
      this.updateStructure(structure, results[resultIndex])
    }
    return structure
  },

  updateStructure(structureToUpdate, referenceBranch) {
    if (referenceBranch != null && typeof referenceBranch === 'object') {
      let subBranches = Object.keys(referenceBranch)
      for (let subBranch of subBranches) {
        if (
          referenceBranch[subBranch] != null &&
          typeof referenceBranch[subBranch] === 'object'
        ) {
          // 'NaN' string used because it is the way NaN is sent from backend
          if (
            structureToUpdate[subBranch] == null ||
            structureToUpdate[subBranch] === 'NaN'
          ) {
            structureToUpdate[subBranch] = {}
          }
          this.updateStructure(
            structureToUpdate[subBranch],
            referenceBranch[subBranch]
          )
        } else {
          // value
          if (structureToUpdate[subBranch] == null) {
            structureToUpdate[subBranch] = 'NaN' // create the key if it does not exists
          }
        }
      }
    }
  },

  saveGridLayout(mission, configurations, gridlayout) {
    if (mission == null) {
      return
    }
    let configsDto = []
    configurations.forEach((config) => {
      let dto = {}
      dto.xzero = config.xzero
      dto.yzero = config.yzero
      dto.xlog = config.xlog
      dto.ylog = config.ylog
      if (config.durationSliderOptions && config.durationSliderValue) {
        dto.durationSliderValue = config.durationSliderValue
        dto.durationSliderOptions = config.durationSliderOptions
      }
      dto.id = config.id
      dto.name = config.name
      dto.type = config.type
      if (config.x) {
        dto.x = config.x
      }
      if (config.y) {
        dto.y = config.y
      }
      if (config.z) {
        dto.z = config.z
      }
      if (config.multiAxis) {
        dto.multiAxis = config.multiAxis
      }
      if (config.filters) {
        dto.filters = config.filters
      }
      if (config.parameters) {
        dto.parameters = config.parameters
      }
      if (config.targets) {
        dto.targets = config.targets
      }
      dto.scatterMode = config.scatterMode
      dto.scatterShape = config.scatterShape
      dto.scatterText = config.scatterText
      dto.width = config.width
      dto.height = config.height
      dto.gridItem = config.gridItem
      configsDto.push(dto)
    })
    mission.layout = JSON.stringify({
      configurations: configsDto,
      layout: gridlayout
    })
    return mission
  },

  // Deserialize layout from back
  loadGridLayoutConfig(missionConfigs, self) {
    let configs = missionConfigs.configurations
    let gridlayout = missionConfigs.layout
    if (gridlayout == null) {
      self.gridlayout = self.defaultLayout
    } else {
      self.gridlayout = gridlayout
    }
    self.configurations = []
    if (configs != null) {
      configs.forEach((config) => {
        let newConf = self.buildEmptyConfiguration(config.id)
        newConf.xzero = config.xzero
        newConf.yzero = config.yzero
        newConf.xlog = config.xlog
        newConf.ylog = config.ylog
        newConf.x = config.x
        newConf.y = config.y
        newConf.z = config.z
        newConf.name = config.name
        newConf.type = config.type
        if (config.durationSliderValue) {
          newConf.durationSliderOptions = config.durationSliderOptions
          newConf.durationSliderValue = config.durationSliderValue
        }
        if (config.multiAxis) {
          newConf.multiAxis = config.multiAxis
        }
        if (config.filters) {
          newConf.filters = config.filters
        }
        if (config.parameters) {
          newConf.parameters = config.parameters
        }
        if (config.targets) {
          newConf.targets = config.targets
        }
        newConf.scatterMode = config.scatterMode
        newConf.scatterShape = config.scatterShape
        newConf.scatterText = config.scatterText
        newConf.width = config.width
        newConf.height = config.height
        newConf.gridItem = self.gridlayout.find((el) => {
          return el.i === `plot${newConf.id}`
        })
        newConf.isDrawn = true
        self.configurations.push(newConf)
      })
    }
  },

  getInfos(item) {
    let infos = ''
    if (item != null) {
      let fieldDesc = fieldsDescription[item.typeName]
      if (!fieldDesc) {
        return
      }
      let tooltips = Object.entries(fieldDesc.properties)
        .map((el) =>
          el[1].tooltip
            ? { field: el[0], value: el[1].tooltip, type: el[1].type }
            : null
        )
        .filter((el) => el != null)
      tooltips.forEach((tooltip) => {
        let instance = item
        let label = fieldDesc.properties[tooltip.field].label
        let type = fieldDesc.properties[tooltip.field].type
        let fieldName = tooltip.field
        if (typeof tooltip.value === 'string') {
          instance = instance[tooltip.field]
          label =
            label +
            ' ' +
            fieldsDescription[tooltip.type].properties[tooltip.value].label
          type = fieldsDescription[tooltip.type].properties[tooltip.value].label
          fieldName = tooltip.value
        }
        let unit = this.getDefaultGuiUnit(type)
        if (instance != null && instance[fieldName] !== undefined) {
          let value = this.convertFromSi(type, instance[fieldName], unit)
          if (value != null && value !== '') {
            if (infos.length > 0) {
              infos += '\n'
            }
            if (unit === 'DHMS' || unit === '24h00') {
              unit = '' // no need to display unit at the end for date/hour format
            }
            infos = infos + label + ' : ' + value + ' ' + unit
          }
        }
      })
    }
    return infos
  },

  computeMaxDutyCycle(orbitalAveragePower, thrusterPower, thrusterStandby) {
    if (isNaN(thrusterStandby) || thrusterStandby === '') {
      thrusterStandby = 0
    }
    if (isNaN(thrusterPower) || thrusterPower === '') {
      return ''
    }
    if (isNaN(orbitalAveragePower) || orbitalAveragePower === '') {
      return ''
    }
    if (thrusterStandby >= orbitalAveragePower) {
      // weird use case, just for robustness
      return 0
    }
    if (thrusterStandby >= thrusterPower) {
      // weird use case, just for robustness
      return 100 // thrusterPower < thrusterStandby < orbitalAveragePower
    }
    const maxDutyCycle =
      (orbitalAveragePower - thrusterStandby) /
      (thrusterPower - thrusterStandby)
    return Math.floor(Math.min(maxDutyCycle, 1) * 100)
  },

  computeMaxDutyCycleWithWarmup(
    orbitalAveragePower,
    thrusterPower,
    thrusterStandby,
    thrusterWarmupPower,
    warmupDutyCycle
  ) {
    if (isNaN(warmupDutyCycle) || warmupDutyCycle === '') {
      warmupDutyCycle = 0
    }
    if (isNaN(thrusterWarmupPower) || thrusterWarmupPower === '') {
      thrusterWarmupPower = 0
    }
    if (isNaN(thrusterStandby) || thrusterStandby === '') {
      thrusterStandby = 0
    }
    if (isNaN(thrusterPower) || thrusterPower === '') {
      return ''
    }
    if (isNaN(orbitalAveragePower) || orbitalAveragePower === '') {
      return ''
    }
    if (thrusterStandby >= orbitalAveragePower) {
      // weird use case, just for robustness
      return 0
    }
    if (thrusterStandby >= thrusterPower) {
      // weird use case, just for robustness
      return 100 // thrusterPower < thrusterStandby < orbitalAveragePower
    }
    const maxDutyCycle =
      (orbitalAveragePower -
        thrusterWarmupPower * warmupDutyCycle -
        (1 - warmupDutyCycle) * thrusterStandby) /
      (thrusterPower - thrusterStandby)
    if (maxDutyCycle < 0) {
      // weird use case, just for robustness
      return 0
    }
    return Math.min(maxDutyCycle, 1) * 100
  },

  formatAngle(alpha) {
    let d = Math.floor(Math.abs(alpha))
    let m = (Math.abs(alpha) - d) * 60
    let s = Math.round((m - Math.floor(m)) * 60)

    m = Math.floor(m)

    if (s === 60) {
      s = 0
      m = m + 1
    }

    if (m === 60) {
      m = 0
      d = d + 1
    }

    if (alpha < 0) {
      d = -d
    }

    return `${d}°${m}'${s}"`
  },

  setAngleDegAround0(angle) {
    if (angle > 90) {
      return angle - 180
    } else if (angle < -90) {
      return angle + 180
    }
    return angle
  },

  downloadFile(name, textContent, extension = 'csv', utf8 = true) {
    const encodingCharacter = utf8 ? '\ufeff' : ''
    let blob = new Blob([encodingCharacter + textContent])
    let a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
    a.download = name + '.' + extension
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },

  getTypeLabel(ojectClass, typeValue) {
    if (fieldsDescription[ojectClass] == null) {
      return 'Error: ' + ojectClass + ' not found in fields description file.'
    }
    if (fieldsDescription[ojectClass].properties.type == null) {
      return 'Error: no type value in fields description file for ' + ojectClass
    }
    return fieldsDescription[ojectClass].properties.type.values.find(
      (typeItem) => typeItem.value === typeValue
    ).text
  }
}
